import React from "react";
import PropTypes from "prop-types";
import AppUtils from "@src/utils/appUtils";
import { COMMON_CONTROLS } from "@src/stories/utils/common-controls";
import ImageWithRetry from "../atoms/ImageWithRetry";

// Layout types:
// equal ==> 50-50 spread
// flex-bottom ==> 1st child grows and 2nd child sits at the bootm of the layout
// flex-top ==> 1st child at top of layout and 2nd child grows

const VerticalLayout = ({
  children,
  title = undefined,
  footerImage = undefined,
  footerLink = undefined,
  layoutType = undefined,
  gap = 0,
  className = "",
  reverse = false,
}) => {
  return (
    <div className={`w-full flex flex-col gap-2 h-full ${className}`}>
      {title && (
        <div className="text-lg font-bold">
          {typeof title === "string" ? <h4>{title}</h4> : title}
        </div>
      )}
      {/* Content styled based on layoutType */}
      <div
        className={
          layoutType !== "equal"
            ? `flex flex-col h-full gap-${gap}`
            : `grid grid-rows-2 gap-${gap}`
        }
      >
        <div
          className={
            layoutType === "flex-bottom"
              ? "flex-1"
              : layoutType === "flex-top"
                ? "h-auto"
                : "row-span-1"
          }
        >
          {reverse ? children[1] : children[0]}
        </div>
        <div
          className={
            layoutType === "flex-bottom"
              ? "h-auto"
              : layoutType === "flex-top"
                ? "flex-1"
                : "row-span-1"
          }
        >
          {reverse ? children[0] : children[1]}
        </div>
      </div>
      {/* Optional footer part */}
      {footerImage ? (
        <div className="mt-auto self-end">
          <div className="relative block w-full h-auto">
            <ImageWithRetry
              src={footerImage}
              alt=""
              className="block w-full h-auto"
            />
            {footerLink && (
              <div className="absolute inset-0 flex items-center justify-center text-white font-bold">
                <a href={footerLink.link}>{footerLink.label}</a>
              </div>
            )}
          </div>
        </div>
      ) : !!footerLink?.link ? (
        <div className="p-6">
          <a href={footerLink.link} className="underline cursor-pointer">
            {footerLink.label}
          </a>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};

export const verticalLayoutControls = {
  title: {
    propType: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    description: "Card title",
    controlType: "text",
  },
  children: {
    propType: PropTypes.oneOfType([
      PropTypes.node,
      PropTypes.element,
      PropTypes.string,
    ]),
    description: "Card content",
    disable: true,
  },
  footerImage: {
    propTypes: PropTypes.string,
    controlType: "text",
    description: "Footer image",
  },
  footerLink: {
    propTypes: PropTypes.object,
    controlType: "text",
    description: "Footer link",
  },
  layoutType: {
    propType: PropTypes.string,
    controlType: "select",
    options: ["equal", "flex-bottom", "flex-top"],
    description: "Defines how children are spaced",
  },
  gap: {
    propTypes: PropTypes.number,
    controlType: "select",
    options: [0, 1, 2, 3, 4, 5, 6],
    description: "Gap between the 2 sections on the card",
  },
  className: COMMON_CONTROLS.className,
};

VerticalLayout.propTypes = AppUtils.getPropTypeFromControls(
  verticalLayoutControls,
);

export default VerticalLayout;
